import Vue from 'vue';
import merge from 'lodash/merge';

class RolesService
{
    static async getAllRoles()
    {
        return Vue.axios.get('admin/roles/all');
    }

    static async getList(filter, pager)
    {
        return Vue.axios.get('admin/roles', {
            params: merge({}, filter.data(), pager.data())
        });
    }

    static async fetch(id)
    {
        return Vue.axios.get(`admin/roles/${id}`);
    }

    static async create(role)
    {
        return Vue.axios.post(`admin/roles`, role);
    }

    static async update(id, role)
    {
        return Vue.axios.put(`admin/roles/${id}`, role);
    }

    static async remove(id)
    {
        return Vue.axios.delete(`admin/roles/${id}`);
    }
}

export default RolesService;
